// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"997":"css/admin-app.6962","5670":"css/app.6962"}[chunkId] + ".css";
};